import { Download, Edit, ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { cellFormat } from '../../../../../../../../lib/designSystem/Table/cellFormat';
import {
  formatDate,
  hasAnyPermissions,
} from '../../../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../../../services/redux/authSlice';
import EntryLinesDetail from './components/EntryLinesDetail';
import { exportEntryToXLXS } from './components/exportEntry';

const statusMap: Record<string, string> = {
  PENDING: 'En espera',
  CLOSED: 'Completado',
};
const useStyles = makeStyles(() =>
  createStyles({
    table: {
      width: '100%',
    },
    tableCell: {
      padding: '8px !important',
      overflow: 'hidden',
      minWidth: '50px',
      maxWidth: '180px',
      whiteSpace: 'nowrap',
      fontSize: '14px !important', // Reduced font size
    },
    tableCellTasa: {
      padding: '8px !important',
      overflow: 'hidden',
      maxWidth: '50px',
      whiteSpace: 'nowrap',
      fontSize: '14px !important', // Reduced font size
      textAlign: 'right',
    },
    tableCellNames: {
      padding: '8px !important',
      overflow: 'hidden',
      maxWidth: '80px',
      whiteSpace: 'nowrap',
      fontSize: '14px !important', // Reduced font size
    },
    tableContainer: {
      border: '1px solid #e0e0e0',
      borderRadius: '10px',
    },
    tableBody: {
      backgroundColor: '#ffffff',
    },
    textField: {
      fontSize: '14px !important',
      padding: '8px !important',
    },
    textFieldAutocomplete: {
      fontSize: '14px !important',
      padding: '0px !important',
      minWidth: '120px !important',
    },
    iconButton: {
      padding: '5px',
    },
  }),
);

const AccountingEntriesTable = (props: any) => {
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const { entries, handleEditEntry, nodes } = props;
  const [expandedDays, setExpandedDays] = useState<Record<number, boolean>>({});
  const classes = useStyles();

  const toggleDay = (dayIndex: number) => {
    setExpandedDays((prev) => ({ ...prev, [dayIndex]: !prev[dayIndex] }));
  };

  return (
    <div style={{ paddingBottom: 100 }}>
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>ID comprobante</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Asiento</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {entries.map((day: any, dayIndex: number) => (
              <React.Fragment key={dayIndex}>
                {/* Nivel 1: Día */}
                <TableRow>
                  <TableCell className={classes.tableCell}>{day.id}</TableCell>
                  <TableCell className={classes.tableCell}>
                    {day.class}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {formatDate(day.date)}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {day.name}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {cellFormat(statusMap[day.status], 'status-chip')}
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ textAlign: 'right' }}
                  >
                    <IconButton onClick={() => toggleDay(dayIndex)}>
                      {expandedDays[dayIndex] ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                    {hasAnyPermissions(user, [
                      'accounting_write_entries',
                      'accounting_delete_entries',
                    ]) && (
                      <IconButton onClick={() => handleEditEntry(day.id)}>
                        <Edit />
                      </IconButton>
                    )}
                    <IconButton
                      onClick={() => {
                        exportEntryToXLXS(day, nodes).catch((error) =>
                          console.error('Error exporting entry:', error),
                        );
                      }}
                      title="Exportar a Excel"
                    >
                      <Download />
                    </IconButton>
                  </TableCell>
                </TableRow>

                {expandedDays[dayIndex] && (
                  <TableRow>
                    <TableCell colSpan={5} style={{ padding: 0 }}>
                      <Collapse
                        in={expandedDays[dayIndex]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <EntryLinesDetail
                          lines={day.lines}
                          classes={classes}
                          nodes={nodes}
                        />
                      </Collapse>
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default AccountingEntriesTable;
